import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgBubble(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        d="M11.25 13.2085C11.25 14.106 10.5225 14.8335 9.625 14.8335C8.72754 14.8335 8 14.106 8 13.2085C8 12.311 8.72754 11.5835 9.625 11.5835C10.5225 11.5835 11.25 12.311 11.25 13.2085Z"
      />
      <path
        fill="currentColor"
        d="M17.5 13.2085C17.5 14.106 16.7725 14.8335 15.875 14.8335C14.9775 14.8335 14.25 14.106 14.25 13.2085C14.25 12.311 14.9775 11.5835 15.875 11.5835C16.7725 11.5835 17.5 12.311 17.5 13.2085Z"
      />
      <path
        fill="currentColor"
        d="M23.75 13.2085C23.75 14.106 23.0225 14.8335 22.125 14.8335C21.2275 14.8335 20.5 14.106 20.5 13.2085C20.5 12.311 21.2275 11.5835 22.125 11.5835C23.0225 11.5835 23.75 12.311 23.75 13.2085Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3 3.75C2.66798 3.75 2.3496 3.88209 2.1151 4.11714C1.8806 4.35218 1.74924 4.67086 1.75 5.00288L1.79151 23.0029C1.7931 23.6921 2.35227 24.25 3.0415 24.25H7.20817V29C7.20817 29.4586 7.45934 29.8804 7.86256 30.099C8.26579 30.3175 8.75631 30.2977 9.14057 30.0473L18.0378 24.25H29C29.332 24.25 29.6504 24.1179 29.8849 23.8829C30.1194 23.6478 30.2508 23.3291 30.25 22.9971L30.2085 4.99712C30.2069 4.30789 29.6477 3.75 28.9585 3.75H3ZM4.28863 21.75L4.25289 6.25H27.7114L27.7471 21.75H17.6665C17.4242 21.75 17.1871 21.8204 16.9841 21.9527L9.70817 26.6936V23C9.70817 22.3096 9.14853 21.75 8.45817 21.75H4.28863Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgBubble);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
